import { Avatar, Box, Typography } from '@material-ui/core';
import React, { Component } from 'react';
import Dialog from '../../../../../commonModules/interface/Dialog';
import PopUp from '../../../../../commonModules/interface/PopUp';
import {BIN_TYPES} from './FormSubProduct';


class SingleSubProduct extends Component {
    state = {  }
    render() {
        const { product } = this.props;
        console.log('================SingleSubProduct SingleSubProduct SingleSubProduct====================');
        console.log({product});
        console.log('====================================');
        return (
            <Dialog
                title={product.name}
                block={true}
                close={this.props.closePopup}
                maxWidth="sm"
            >
                <Box style={{ display:"flex", justifyContent:"space-around"}}>
                    <Avatar style={{width: "100px", height: "100px"}} alt={product.name} src={product.photos && product.photos.length > 0 && product.photos[0].filename ? `/stocks/photos/${product.photos[0].filename}` : 'img/noImg.png'} />

                    <Box>
                        <Typography variant="body1" gutterBottom>Type: {BIN_TYPES[product.bin_type]}</Typography>
                        <Typography variant="body1" gutterBottom>Poids: {product.poids}g</Typography>
                        <Typography variant="body1" gutterBottom>Quantité: {product.quantity}</Typography>
                        <Typography variant="body1" gutterBottom>Description: {product.product_desc}</Typography>
                    </Box>

                </Box>
            </Dialog>
        );
    }
}

export default SingleSubProduct;